// Inline error panel for a failed pane fetch (401/403/404/error). Never swallow
// failures (doctrine 1.5).
export function SellerErrorState({
  title,
  message,
  onRetry,
}: {
  title: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="sl-center">
      <div className="sl-error">
        <div className="sl-error__title">{title}</div>
        <div>{message}</div>
        {onRetry ? (
          <div style={{ marginTop: "var(--rc-space-4)" }}>
            <button className="sl-btn sl-btn--ghost" onClick={onRetry}>
              Retry
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
